const Header = () => {
  return (
    <h1 className="text-md mt-6 text-center sm:text-2xl">
      Create Actionable Content
    </h1>
  );
};

export default Header;
